import logo from './logo.svg';
import './App.css';
import {useEffect, useState} from "react";

import {FiSend} from "react-icons/fi";
import {FaHourglassHalf} from "react-icons/fa";

import {motion} from "framer-motion";

import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";

function ThinkingIndicator() {
    return (
        <motion.span
            className="h-3 w-3 rounded-full thinking-indicator"
            animate={{
                scale: [1, 1.4, 1],      // 살짝 커졌다 돌아오고
                opacity: [1, 0.4, 1],    // 동시에 투명도 변화
            }}
            transition={{
                duration: 1.2,           // 한 사이클 1.2초
                repeat: Infinity,        // 무한 반복
                ease: "easeInOut",
            }}
        />
    );
}

function render() {
    const src = document.getElementById("video");
    const mask = document.getElementById("mask");
    const cvs = document.getElementById("canvas");
    const ctx = cvs.getContext("2d");

    const maskCvs = new OffscreenCanvas(1, 1);            // 오프스크린으로 처리
    const mCtx = maskCvs.getContext('2d', {willReadFrequently: true});

    if (src.readyState >= 2 && mask.readyState >= 2) {
        const w = cvs.width = src.videoWidth;
        const h = cvs.height = src.videoHeight;

        // 1) 원본 프레임
        ctx.drawImage(src, 0, 0, w, h);

        // 2) ===== 마스크: 그레이 → 알파 변환 =====
        maskCvs.width = w;
        maskCvs.height = h;
        mCtx.drawImage(mask, 0, 0, w, h);

        const frame = mCtx.getImageData(0, 0, w, h);
        const d = frame.data;              // Uint8ClampedArray

        // R(또는 (R+G+B)/3) → A 복사
        for (let i = 0; i < d.length; i += 4) {
            const lum = d[i];                // d[i] = R; 그레이라면 R=G=B
            d[i + 3] = lum;                 // alpha 채널
            d[i] = d[i + 1] = d[i + 2] = 255;    // 흰색(색상은 중요 X)
        }
        mCtx.putImageData(frame, 0, 0);

        // 3) 합성
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(maskCvs, 0, 0, w, h);
        ctx.globalCompositeOperation = 'source-over';

        // console.log("Rendered frame with mask applied");
    }
    requestAnimationFrame(render);
}

async function fetchMessage(logs, token) {
    const response = await fetch("/api/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({token, logs})
    });

    if (!response.ok) {
        throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data.message;
}

function MainPage() {
    const [logs, setLogs] = useState([]);
    const [isActive, setIsActive] = useState(false);
    const [inputText, setInputText] = useState("");
    const [token, setToken] = useState(null);

    const personName = "Bot";

    useEffect(() => {
        (async () => {
            // Acquire a token from the server
            try {
                const response = await fetch("/api/visit");
                if (!response.ok) {
                    throw new Error(`Failed to fetch token: ${response.statusText}`);
                }
                const data = await response.json();
                setToken(data.token);
                setIsActive(true);
            } catch (error) {
                console.error("Error fetching token:", error);
                setLogs([`Error fetching token: ${error.message}`]);
            }
        })();
    }, []);

    useEffect(() => {
        // scroll to the bottom of the chat logs whenever logs change
        const logsContainer = document.querySelector(".logs");
        if (logsContainer) {
            logsContainer.scrollTop = logsContainer.scrollHeight;
        }
    }, [logs]);

    useEffect(() => {
        const video = document.getElementById("video");
        const mask = document.getElementById("mask");

        let running = false;
        let ready_video = false;
        let ready_mask = false;

        video.oncanplaythrough = async () => {
            ready_video = true;
            if (ready_mask) {
                if (!running) {
                    running = true;
                    await Promise.all([
                        video.play(),
                        mask.play(),
                    ]);
                    requestAnimationFrame(render);
                }
            }
        }

        mask.oncanplaythrough = async () => {
            ready_mask = true;
            if (ready_video) {
                if (!running) {
                    running = true;
                    await Promise.all([
                        video.play(),
                        mask.play(),
                    ]);
                    requestAnimationFrame(render);
                }
            }
        }

        video.src = "/data/idle_001.mp4";
        mask.src = "/data/idle_001_mask.mp4";
    }, []);

    async function submitMessage() {
        if (inputText.trim() === "") return;
        if (!isActive) return;

        setIsActive(false);
        setInputText("");
        setLogs((prevLogs) => [...prevLogs, inputText]);

        try {
            const response = await fetchMessage([...logs, inputText], token);
            setLogs((prevLogs) => [...prevLogs, response]);
        } catch (error) {
            console.error("Error fetching message:", error);
            setLogs((prevLogs) => [...prevLogs, `Error fetching response: ${error.message}`]);
        }

        setIsActive(true);
    }

    return (
        <div className="wrapper">
            <video id={"video"} muted playsInline loop/>
            <video id={"mask"} muted playsInline loop/>
            <div className="screen">
                <img id="body-image" src="/data/body_image.png" alt="Body"/>
                <canvas id="canvas"/>
                <div className={"chat"}>
                    <div className={"logs"}>
                        {
                            logs.map((log, index) => {
                                if (index % 2 === 0) {
                                    return <div key={index} className={"msg log-user"}>{log}</div>;
                                } else {
                                    return (
                                        <div key={index} className={"log-bot-container"}>
                                            <span className={"bot-name"}>{personName}</span>
                                            <div className={"msg log-bot"}>
                                                {log}
                                            </div>
                                        </div>
                                    );
                                }
                            })
                        }
                        {
                            !isActive && (
                                <div className={"log-bot-container"}>
                                    <span className={"bot-name"}>{personName} <ThinkingIndicator/></span>
                                    <div className={"msg log-bot log-bot-thinking"}>
                                        Thinking...
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className={"input-area"}>
                        <input id={"input-text"} type="text" placeholder="Type your message here..." value={inputText}
                               onChange={(e) => setInputText(e.target.value)}
                               onKeyDown={(e) => {
                                   if (e.key === 'Enter' && isActive) {
                                       submitMessage();
                                   }
                               }}
                        />
                        <button id={"input-button"} onClick={submitMessage}>
                            {isActive ? <FiSend size={18}/> : <FaHourglassHalf size={18}/>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function AdminPage() {
    const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7)); // YYYY-MM format
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSessionId, setSelectedSessionId] = useState(null);

    const [visits, setVisits] = useState([]);
    const [sessionsByDate, setSessionsByDate] = useState([]);
    const [chatHistory, setChatHistory] = useState([]);

    useEffect(() => {
        (async () => {
            const response = await fetch(`/api/admin/visits?month=${selectedMonth}`);

            if (!response.ok) {
                console.error("Failed to fetch visits:", response.statusText);
                return;
            }

            const data = await response.json();

            console.log("Visits data for month", selectedMonth, ":", data);

            const dateMap = {};

            (data || []).forEach(visit => {
                const key = `${selectedMonth}-${visit.day.toString().padStart(2, '0')}`;
                dateMap[key] = {
                    date: key,
                    visitors: visit.count || 0,
                    activeUsers: visit.active || 0,
                };
            });

            // for the current month, fill in the missing dates
            const currentDate = new Date(selectedMonth);
            const daysInMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();

            const visitsArray = Array.from({length: daysInMonth}, (_, i) => {
                const day = (i + 1).toString().padStart(2, '0');
                const key = `${selectedMonth}-${day}`;
                return dateMap[key] || {
                    date: key,
                    visitors: 0,
                    activeUsers: 0,
                };
            });

            setVisits(visitsArray);
        })();
    }, [selectedMonth]);

    useEffect(() => {
        (async () => {
            if (!selectedDate) return;

            setSessionsByDate(["Loading..."]); // Clear previous sessions

            const response = await fetch(`/api/admin/sessions?date=${selectedDate}`);

            if (!response.ok) {
                console.error("Failed to fetch sessions:", response.statusText);
                return;
            }

            const data = await response.json();

            console.log("Sessions data for date", selectedDate, ":", data);

            setSessionsByDate(data.map(session => session.session));
        })();
    }, [selectedDate]);

    useEffect(() => {
        (async () => {
            if (!selectedSessionId) return;

            setChatHistory(["Loading..."]); // Clear chat history before fetching new one

            const response = await fetch(`/api/admin/logs?date=${selectedDate}&session=${selectedSessionId}`);

            if (!response.ok) {
                console.error("Failed to fetch chat history:", response.statusText);
                return;
            }

            const data = await response.json();

            console.log("Chat history for session", selectedSessionId, ":", data);

            setChatHistory((data.logs || []).map((line, index) => {
                if (index % 2 === 0) {
                    return "User: " + line;
                } else {
                    return "Bot: " + line;
                }
            }));
        })();
    }, [selectedSessionId]);

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
        setSelectedDate(null);
        setSelectedSessionId(null);
    };

    const handleDateClick = (date) => {
        setSelectedDate(date);
        setSelectedSessionId(null);
    };

    const handleSessionClick = (sessionId) => {
        setSelectedSessionId(sessionId);
    };

    return (
        <div className="container">
            <div className="top-section">
                <label>
                    Select Month:
                    <input
                        type="month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                    />
                </label>
                <div className="chart">
                    {visits.map((stat) => (
                        <div
                            key={stat.date}
                            className={`chart-bar ${selectedDate === stat.date ? "selected" : ""}`}
                            onClick={() => handleDateClick(stat.date)}
                            title={`Visitors: ${stat.visitors}, Active: ${stat.activeUsers}`}
                        >
                            <div
                                className="bar"
                                style={{height: stat.visitors + 10 + "px"}}
                            ></div>
                            <span className="bar-label">{stat.date.split("-")[2]}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className="bottom-section">
                <div className="user-list">
                    <h3>Sessions on {selectedDate}</h3>
                    <ul>
                        {selectedDate &&
                            sessionsByDate.map((sessionId) => (
                                <li
                                    key={sessionId}
                                    className={selectedSessionId === sessionId ? "selected" : ""}
                                    onClick={() => handleSessionClick(sessionId)}
                                >
                                    {sessionId}
                                </li>
                            ))}
                    </ul>
                </div>

                <div className="chat-history">
                    <h3>Chat History for {selectedSessionId}</h3>
                    <div className="chat-box">
                        {selectedSessionId &&
                            chatHistory.map((line, idx) => <div key={idx}>{line}</div>)}
                    </div>
                </div>
            </div>
        </div>
    );
}

const router = createBrowserRouter([
    {
        path: "/",
        element: <MainPage/>,
    },
    {
        path: "/admin",
        element: <AdminPage/>,
    },
]);

export default function App() {
    return (
        <RouterProvider router={router}/>
    );
};
